<template>
    <cp-select
        :config="routeData"
        item-value="id"
        item-text="name"
        clearable
        v-on="$listeners"
        v-bind="attrs"
        :persistent="true"
        :ignoreItem="ignoreItem"
        :returnObject="false"
    />
</template>

<script>

export default {
    props: {
        ignoreItem: {
            type: Number,
            require: false
        }
    },

    data: () => ({
        routeData: {route: 'v2.nps.researches.json'},
    }),

    computed: {
        attrs() {
            const { label, name, ...attrs } = this.$attrs;

            return { ...{
                label: label || 'Selecione uma pesquisa',
                name: name || "select-research"
            }, ...attrs };
        },
    },
}
</script>